import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetEk83ReportListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined,
    currentPage: number,
    startDate: string | undefined
    endDate: string | undefined
    selectedReceiverFirm: CustomSingleSelectModel | undefined
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
}

export const initialGetEk83ReportListPagingAndFilterRequest: GetEk83ReportListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    startDate: undefined,
    endDate: undefined,
    selectedReceiverFirm: undefined,
    columnFilters: []
}